import {IAtributeOptions, IAttributeValue} from "../../../types/widgetFiltresTypes";
import React, {FC, Fragment, useEffect, useRef, useState} from "react";
import cls from "./category.module.scss";
import {ArrowRoundedDown12x7Svg, Check12x9Svg} from "../../../svg";
import {useSelector} from "react-redux";
import {IState} from "../../../types/state";
import {useRouter} from "next/router";
import {handleFilterChange} from "./helpers";

interface IFilterColorProps {
    data: Array<IAtributeOptions>,
    title: any,
    value: IAttributeValue
}

const CustomFilterColor: FC<IFilterColorProps> = (
    {
        data,
        value: {attributes: [{code = ""}] = []},
        title
    }
) => {
    const sidebarOpen = useSelector((state: IState) => state.sidebar.open)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [filterListHeight, setFilterListHeight] = useState<boolean>(false)
    const checkRef = useRef<{ current?: { clientHeight?: number } } | any>(null);
    const router = useRouter();

    useEffect(() => {
        if (!filterListHeight) {
            setFilterListHeight(checkRef.current?.clientHeight > 88)
        }
    }, [checkRef.current?.clientHeight, sidebarOpen])

    return (
        <div
            className={`${cls["filter-list"]} ${!isOpen && filterListHeight ? cls["filter-list__closed"] : ""}`}
            ref={checkRef}
        >
            <div className={cls.widget__title} onClick={() => {
                if (filterListHeight) {
                    setIsOpen(prevState => !prevState)
                }
            }}>
                {title}
                {filterListHeight ? (
                    <button
                        className={`${cls.filter__item} ${isOpen && cls.open}`}
                        type="button"
                        onClick={() => setIsOpen(prevState => prevState)}
                    >
                        <ArrowRoundedDown12x7Svg className={cls["mobile-links__item-arrow"]}/>
                    </button>
                ) : <Fragment />}
            </div>
            <div className={cls["filter-color__list"]}>
                {data?.map((item: IAtributeOptions, index: number) => {
                    const checked = String(router.query?.[`filter_${code}`]).split(",")
                        .some(elem => elem ===  String(item.id))
                    return (
                        <div className={cls["filter-color__item"]} key={index}>
                            <span
                                className={`
                                    ${cls["filter-color__check"]}
                                    ${cls["input-check-color"]}
                                    ${cls[`input-check-color--${item.stringifyColorType.toLowerCase()}`]}
                                `}
                                style={{color: item.swatch_value || `${item.admin_name}`.toLowerCase()}}
                            >
                                <label className={cls["input-check-color__body"]}>
                                    <input
                                        className={cls["input-check-color__input"]}
                                        type="checkbox"
                                        value={item.id}
                                        checked={checked}
                                        disabled={item.count === 0}
                                        onChange={(e) => handleFilterChange(e, router, code)}
                                    />
                                    <span className={cls["input-check-color__box"]}/>
                                        <Check12x9Svg className={cls["input-check-color__icon"]}/>
                                    <span className={cls["input-check-color__stick"]}/>
                                </label>
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CustomFilterColor;